import React from 'react';
import { Button, ButtonProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { theme } from '../../theme';

interface SearchButtonProps extends Omit<ButtonProps, 'type' | 'icon'> {
  /**
   * Texto del botón
   * @default "Buscar"
   */
  text?: string;
}

/**
 * Componente Botón de Búsqueda reutilizable
 * Pre-configurado con ícono SearchOutlined y estilos del theme
 */
export const SearchButton: React.FC<SearchButtonProps> = ({ 
  text = "Buscar",
  style = {},
  ...restProps 
}) => {
  return (
    <Button
      type="primary"
      size="small"
      icon={<SearchOutlined />}
      style={{
        backgroundColor: theme.colors.primary,
        borderColor: theme.colors.primary,
        fontWeight: 500,
        height: '40px',
        ...style
      }}
      {...restProps}
    >
      {text}
    </Button>
  );
};

